import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-888da9d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menus" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "content" }

import { PageConfig } from '../router/index';
import { useZsStore } from '../store';
import { useRoute } from 'vue-router';
import { useParentHeight } from '../hooks/use-parent-height';
import { watch } from 'vue';
import { getConfig } from '../data-source/api';
import { PUBLISH_SOURCE_COMPANY, PUBLISH_SOURCE_SYSTEM } from '../config';
import { throttle } from 'lodash';

type FirstParameter<T> = T extends (a: infer P, ...args: any) => any
  ? P
  : never;


export default /*#__PURE__*/_defineComponent({
  __name: 'zs-manage-layout',
  setup(__props) {

const route = useRoute();

const { setValue, isOssRole } = useZsStore();

watch(
  () => route.query,
  throttle(newQuery => {
    (
      ['enterpriseName', 'enterpriseId', 'configId'] as Array<
        FirstParameter<typeof setValue>
      >
    ).forEach((key: any) => {
      setValue(key, newQuery[key] as string);
      if (key === 'configId') {
        if (isOssRole.value) {
          setValue('dataOrigin', 'own');
        } else {
          getConfig({ configId: newQuery[key] as string }).then(({ data }) => {
            if (data && Object.keys(data).length > 0) {
              if (
                (isOssRole.value && data.source == PUBLISH_SOURCE_SYSTEM) ||
                (!isOssRole.value && data.source == PUBLISH_SOURCE_COMPANY)
              ) {
                setValue('dataOrigin', 'own');
              } else {
                setValue('dataOrigin', 'other');
              }
            } else {
              setValue('dataOrigin', 'own');
            }
          });
        }
      }
    });
  }, 1000),
  { immediate: true, deep: true }
);

const parentDomHeight = useParentHeight();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["box", { vertical: _unref(isOssRole) }]),
    style: _normalizeStyle({ '--parent-dom-height': _unref(parentDomHeight) })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PageConfig), ({ label, name, path, icon }) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          replace: _unref(isOssRole),
          class: _normalizeClass(["item", { active: _unref(route).path === path }]),
          to: { path: path, query: _unref(route).query },
          key: name
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "icon",
              innerHTML: icon
            }, null, 8, _hoisted_2),
            _createElementVNode("p", null, _toDisplayString(label), 1)
          ]),
          _: 2
        }, 1032, ["replace", "class", "to"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_view, { class: "router" }, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 1
      })
    ])
  ], 6))
}
}

})